import { PureComponent } from 'react';
import cx from 'classnames';
import styles from 'partials/checkbox.module.scss';

export class Checkbox extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			isChecked: props.isChecked || false
		};
	}

	handleInput = (e) => {
		this.setState({
			isChecked: e.target.checked
		});
	};

	handleCheckbox = (e) => {
		e.stopPropagation();
		this.raiseChange();
	};

	raiseChange = (checked = '') => {
		var checked_value = checked === '' ? !this.state.isChecked : checked;
		this.setState({
			isChecked: checked_value
		});
		this.props.onChange?.(this.props.item, checked_value)
	};

	componentDidUpdate(prevProps) {
		if (prevProps.isChecked !== this.props.isChecked) {
			this.setState({
				isChecked: this.props.isChecked
			});
			this.raiseChange(this.props.isChecked);
		}
	}

	render() {
		const checkboxClass = cx(styles.box, this.props.className, {
			[styles.checked]: this.state.isChecked
		});
		const props = this.props;
		const Icon = props.icon;

		return (
			<div
				role="button"
				tabIndex="0"
				className={checkboxClass}
				onClick={this.handleCheckbox}
				onKeyPress={this.handleCheckbox}>
				<input
					type="checkbox"
					className={styles.input}
					id={props.id}
					value={props.id}
					checked={this.state.isChecked}
					onChange={this.handleInput}
				/>
				<div className={styles.body}>
					{props.icon && (
						<Icon
							className={cx(styles.icon, props.iconClass)}
							size={24}
						/>
					)}
					<span className={styles.label}>{props.label}</span>
				</div>

				<div className={styles.track}>
					<span className={styles.indicator}></span>
				</div>
			</div>
		);
	}
}
